import icCheckbox from "img/icons/Checkbox--inactive.svg";
import icCheckboxActive from "img/icons/Checkbox.svg";
import icBolt from "img/lockMMY/small-bolt.svg";
import icNFT from "img/lockMMY/nft.png";
import icBoost from "img/lockMMY/boost.svg";
import { useWeb3React } from "@web3-react/core";
import useGetListStakedNFTv2 from "hooks/useGetListStakedNFTv2";
const StakeNFT = ({ setPendingTxns, pendingTxns, connectWallet }) => {
  const { library, account } = useWeb3React();
  const { listMyNFT } = useGetListStakedNFTv2();
  return (
    <div className="lockMMY-info-container stake-nft-container">
      <div className="title">NFTs require</div>
      <div className="lockMMY-content-container">

        <div className="tab-boost">
          <div className="boosted">
            <img src={icBoost} alt="" />
            <div className="boosted-text">Boosted:<span style={{ marginLeft: '4px' }}>0.5%</span></div>
          </div>
          <div className="nft-staked-info">NFT staked: <span style={{ marginLeft: '4px' }}>10</span></div>
        </div>
        <div className="nft-container">
          <div className="nft-info">
            <div className="availavle">
              Available: <span>15</span>
            </div>
            <div className="selectable">
              <div className="availavle">
                Selected: <span>0</span>
              </div>
              <div className="select-btn">Select All</div>
              <div className="select-btn">Deselect All</div>
            </div>
          </div>
          <div className="nft-list-user-container">
            <div className="nft-list-user">
              {[1, 2, 3, 4, 5,6,7,8,9,10,11,12,13,14, 15].map(item => (
                <div className="nft">
                  <img src={icNFT} alt="" className="main-nft-item" />
                  <div className="nft-infor">
                    <img src={icBolt} alt="" /> 1.56K
                  </div>
                  <div className="nft-checkbox">
                    <img src={icCheckboxActive} alt="" />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {account ? <div className="action-buttons">
            <button className="App-button-option">Stake</button>
            <button className="App-button-option border-btn">Unstake</button>
          </div> : <div className="action-buttons">
            <button className="App-button-option">Connect Wallet</button>
          </div>}
        </div>
      </div>
    </div>
  )
}
export default StakeNFT;
